export default "__VITE_ASSET__AToiXhx3__"